<a href="{{environment.wwwUrl}}">
  <img [ngSrc]="'/assets/images/avantlink-fullcolor.svg' | absUrl" height="62" width="410">
</a>
